import { createContext } from "react";

const OcupacionesContext = createContext();

export default OcupacionesContext;
